import axios from "../../../../api/axios";
import { AddEntityLocationsFormData } from "../types/entityBranches.types";

interface CreateEntityBranchesResponse {
  success: boolean;
  message: string;
}

interface FormattedBranch {
  countryId: number;
  name: string;
  address: string;
  googleMapsLink: string;
  isHeadquarter: boolean;
  facilities: number[];
  sports: number[];
  workingHours: Array<{
    dayOfWeek: string;
    openingTime: string;
    closingTime: string;
    isClosed: boolean;
  }>;
}

interface FormattedBranchesData {
  footballEntityId: number;
  branches: FormattedBranch[];
}

interface LocationBranch {
  branchName: string;
  branchAddress: string;
  branchGoogleMapsAddress: string;
  isHeadquarters: boolean;
  workingHours: {
    [key: string]: {
      openingTime: string;
      closingTime: string;
    };
  };
  sports: number[];
  facilities: Array<{
    facilityId: number;
    count: number;
  }>;
}

interface Location {
  country: number;
  branches: LocationBranch[];
}

const formatBranchesData = (data: AddEntityLocationsFormData, entityId: number): FormattedBranchesData => {
  const formattedBranches: FormattedBranch[] = [];

  data.locations.forEach((location: Location) => {
    const countryId = location.country;

    location.branches.forEach((branch: LocationBranch) => {
      // Format working hours
      const workingHours = Object.entries(branch.workingHours)
        .filter(([_, hours]) => hours !== undefined && hours !== null)
        .map(([day, hours]: [string, { openingTime: string; closingTime: string }]) => ({
          dayOfWeek: day.charAt(0).toUpperCase() + day.slice(1),
          openingTime: hours.openingTime,
          closingTime: hours.closingTime,
          isClosed: false,
        }));

      // Format facilities
      const facilities = branch.facilities.map((facility: { facilityId: number }) => facility.facilityId);

      formattedBranches.push({
        countryId,
        name: branch.branchName,
        address: branch.branchAddress,
        googleMapsLink: branch.branchGoogleMapsAddress,
        isHeadquarter: branch.isHeadquarters,
        facilities,
        sports: branch.sports,
        workingHours,
      });
    });
  });

  return {
    footballEntityId: entityId,
    branches: formattedBranches,
  };
};

export const createEntityBranches = async (
  data: AddEntityLocationsFormData,
  entityId: number
): Promise<CreateEntityBranchesResponse> => {
  const formattedData = formatBranchesData(data, entityId);

  const response = await axios.post<CreateEntityBranchesResponse>("/football-entity-branches", formattedData);
  return response.data;
};
